import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

function HiddenFieldEditor ({ field, control }) {
  return (
    <Controller
      name={field.id}
      control={control}
      defaultValue={field.value}
      render={() => null}
    />
  )
}

HiddenFieldEditor.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.any
  }).isRequired,
  control: PropTypes.object.isRequired
}

export default HiddenFieldEditor
